import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfDashboardPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      pages: {
        dashboard: {
          title: "总览",
          subtitle: "围绕静态附件题闭环管理分类、赛题与仓库 Hub 制品发布物。",
          categoriesTitle: "赛题分类",
          categoriesDescription: "维护赛题分类，作为赛题创建的归属入口。",
          challengesTitle: "赛题库",
          challengesDescription: "创建赛题、登记草稿版本，并推进绑定制品与发布。",
          artifactsTitle: "制品发布物",
          artifactsDescription: "人工登记 repo hub artifact，进入 challenge_version 绑定主链。",
          openAction: "进入"
        }
      }
    }
  },
  en: {
    ctf: {
      pages: {
        dashboard: {
          title: "Dashboard",
          subtitle: "Manage static attachment challenges across categories, challenges, and repo hub artifacts.",
          categoriesTitle: "Categories",
          categoriesDescription: "Maintain challenge categories for challenge creation.",
          challengesTitle: "Challenges",
          challengesDescription: "Create challenges, draft versions, bind artifacts, and publish.",
          artifactsTitle: "Artifact Releases",
          artifactsDescription: "Register repo hub artifacts for challenge version binding.",
          openAction: "Open"
        }
      }
    }
  },
  ja: {
    ctf: {
      pages: {
        dashboard: {
          title: "概要",
          subtitle: "静的添付問題について、カテゴリ、問題、repo hub 成果物を管理します。",
          categoriesTitle: "カテゴリ",
          categoriesDescription: "問題作成に使うカテゴリを管理します。",
          challengesTitle: "問題",
          challengesDescription: "問題と草稿バージョンを作成し、成果物を紐付けて公開します。",
          artifactsTitle: "成果物",
          artifactsDescription: "challenge_version に紐付ける repo hub artifact を登録します。",
          openAction: "開く"
        }
      }
    }
  }
};
